import React, { useEffect, useState } from 'react'

import * as AlertDialog from 'primitives/alert_dialog'
import { Stack } from 'primitives/containers'

import { useCallManager } from '../../../contexts/call_manager_context'
import { CS } from './connection_status_reducer'

type ActiveCallAlertProps = {
  activeParticipant?: any
  connectionStatus?: CS
}

export const ActiveCallAlert = ({
  activeParticipant,
  connectionStatus,
}: ActiveCallAlertProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const { joinCall, leaveCall, isJoining } = useCallManager()
  const [isSubmitting, setIsSubmitting] = useState(false)

  useEffect(() => {
    if (
      (activeParticipant?.disconnected_at ||
        connectionStatus === CS.JOIN_ROOM_ERROR) &&
      !isJoining &&
      !isOpen
    ) {
      setIsOpen(true)
    }
    if (
      !activeParticipant?.disconnected_at &&
      connectionStatus !== CS.JOIN_ROOM_ERROR &&
      isOpen
    ) {
      setIsOpen(false)
    }
  }, [isOpen, isJoining, activeParticipant, connectionStatus])

  const handleReconnect = () => {
    if (joinCall) {
      setIsSubmitting(true)
      joinCall()
        .then(
          () => {
            setIsOpen(false)
          },
          () => {
            // do nothing
          },
        )
        .finally(() => {
          setIsSubmitting(false)
        })
    }
  }

  const handleLeave = () => {
    if (leaveCall) {
      setIsSubmitting(true)
      leaveCall()
        .then(
          () => {
            setIsOpen(false)
          },
          () => {
            // do nothing
          },
        )
        .finally(() => {
          setIsSubmitting(false)
        })
    }
  }

  return (
    <AlertDialog.Root open={isOpen}>
      <AlertDialog.Overlay />
      <AlertDialog.Content>
        <AlertDialog.Title css={{ textAlign: 'center' }}>
          Call connection interrupted
        </AlertDialog.Title>

        <Stack
          direction="row"
          gap="3"
          css={{
            width: '100%',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <AlertDialog.Cancel onClick={handleLeave} disabled={isSubmitting}>
            Leave
          </AlertDialog.Cancel>
          <AlertDialog.Action onClick={handleReconnect} disabled={isSubmitting}>
            Reconnect
          </AlertDialog.Action>
        </Stack>
      </AlertDialog.Content>
    </AlertDialog.Root>
  )
}
